import React from 'react';
import { withRouter } from 'react-router-dom';

import ThumbNailLogo from "./../Assets/logos/thumbnail_logo";

const HomeHeader = ({ title, history }) => {
    return (
      <div id="homeHeader" className="homeHeaderFrame">
        <ThumbNailLogo alt=""/>
        <p className="homeHeaderPageTitle" >{title}</p>
        <div className="homeHeaderCallToActionButtonWrap pageLayout">
          <button 
          onClick={() => {history.push('Courses')}}
          className="homeHeaderCallToActionButton">
            View Courses
          </button>
          <button 
          onClick={() => {history.push('Contact')}}
          className="homeHeaderCallToActionButton">
            Contact Us
          </button>
        </div>
      </div>
    )
  }

export default withRouter(HomeHeader);